import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../../api/api';

/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class News {
    
    api_url: String = "http://intranews.appsradiant.com/backend/";

    constructor(public api: Api) { }

    /**
     * Send a GET request to our api menu news endpoint with the data
     */
    getMenuIntranews(args: any) {       
        console.log(this.api_url + 'index.php/service/news/get_menu_intranews'); 
        let seq = this.api.getCustomUrl(this.api_url + 'index.php/service/news/get_menu_intranews', args);
        return seq;
    }

    /**
     * Send a GET request to our api widget news endpoint with the data
     */
    getWidgetIntranews(args: any) {
        let seq = this.api.getCustomUrl(this.api_url + 'index.php/service/news/get_widget_intranews', args);
        return seq;
    }

    /**
     * Send a GET request to our api menu news endpoint with the data
     */
    getMenuDashboard(args: any) {
        let seq = this.api.getCustomUrl(this.api_url + 'index.php/service/news/get_menu_dashboard', args);
        return seq;
    }

    /**
     * Send a GET request to our api widget news endpoint with the data
     */
    getWidgetDashboard(args: any) {
        let seq = this.api.getCustomUrl(this.api_url + 'index.php/service/news/get_widget_dashboard', args);
        return seq;
    }

    /**
    * Send a GET request to our api permission department endpoint with the data
    */
    getPermissionDepartment(args: any) {
        let seq = this.api.getCustomUrl(this.api_url + 'index.php/service/news/get_permission_department', args);
        return seq;
    }

    /**
   * Send a POST request to our save news endpoint with the data
   * the user entered on the form.
   */
    saveNews(argsNews: any) {        
        let seq = this.api.postCustomUrl(this.api_url + 'index.php/service/news/save_news', argsNews);
        return seq;
    }

    getNewsById(nid: Number) {
        let seq = this.api.postCustomUrl(this.api_url + 'index.php/service/news/news_by_id/' + nid,{});
        return seq;
    }

    deleteNews(argsNews: any) {
        let seq = this.api.postCustomUrl(this.api_url + 'index.php/service/news/delete_news', argsNews);
        return seq;
    }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/news/news.ts